import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IExpertise } from "../../utils/types/models";

export default createEntityReducer<IExpertise>(Endpoint.Expertises, Endpoint.ExpertisesList);
